import { render, staticRenderFns } from "./EditCourseControls.vue?vue&type=template&id=540c4334"
import script from "./EditCourseControls.vue?vue&type=script&lang=js"
export * from "./EditCourseControls.vue?vue&type=script&lang=js"
import style0 from "./EditCourseControls.vue?vue&type=style&index=0&id=540c4334&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports